/**
 * @flow
 * @relayHash 334d109bb2d4ab5b8b2bef6e5ae092ec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobDetailsToggleFollowButton_job$ref = any;
export type JobDetailsToggleFollowButtonQueryVariables = {|
  id: string,
  withFollowers: boolean,
|};
export type JobDetailsToggleFollowButtonQueryResponse = {|
  +job: ?{|
    +$fragmentRefs: JobDetailsToggleFollowButton_job$ref
  |}
|};
export type JobDetailsToggleFollowButtonQuery = {|
  variables: JobDetailsToggleFollowButtonQueryVariables,
  response: JobDetailsToggleFollowButtonQueryResponse,
|};
*/

/*
query JobDetailsToggleFollowButtonQuery(
  $id: ID!
  $withFollowers: Boolean!
) {
  job(id: $id) {
    ...JobDetailsToggleFollowButton_job_4hJhOB
    id
  }
}

fragment JobDetailsToggleFollowButton_job_4hJhOB on JobNode {
  id
  isCurrentUserFollowing
  followers {
    edges @include(if: $withFollowers) {
      node {
        id
        fullName
      }
    }
    totalCount
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'id',
        type: 'ID!',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'withFollowers',
        type: 'Boolean!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'Variable',
        name: 'id',
        variableName: 'id'
      }
    ],
    v2 = {
      kind: 'ScalarField',
      alias: null,
      name: 'id',
      args: null,
      storageKey: null
    };
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'JobDetailsToggleFollowButtonQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: 'job',
          storageKey: null,
          args: (v1 /*: any*/),
          concreteType: 'JobNode',
          plural: false,
          selections: [
            {
              kind: 'FragmentSpread',
              name: 'JobDetailsToggleFollowButton_job',
              args: [
                {
                  kind: 'Variable',
                  name: 'withFollowers',
                  variableName: 'withFollowers'
                }
              ]
            }
          ]
        }
      ]
    },
    operation: {
      kind: 'Operation',
      name: 'JobDetailsToggleFollowButtonQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: 'job',
          storageKey: null,
          args: (v1 /*: any*/),
          concreteType: 'JobNode',
          plural: false,
          selections: [
            (v2 /*: any*/),
            {
              kind: 'ScalarField',
              alias: null,
              name: 'isCurrentUserFollowing',
              args: null,
              storageKey: null
            },
            {
              kind: 'LinkedField',
              alias: null,
              name: 'followers',
              storageKey: null,
              args: null,
              concreteType: 'StaffNodeConnection',
              plural: false,
              selections: [
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'totalCount',
                  args: null,
                  storageKey: null
                },
                {
                  kind: 'Condition',
                  passingValue: true,
                  condition: 'withFollowers',
                  selections: [
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'edges',
                      storageKey: null,
                      args: null,
                      concreteType: 'StaffNodeEdge',
                      plural: true,
                      selections: [
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'node',
                          storageKey: null,
                          args: null,
                          concreteType: 'StaffNode',
                          plural: false,
                          selections: [
                            (v2 /*: any*/),
                            {
                              kind: 'ScalarField',
                              alias: null,
                              name: 'fullName',
                              args: null,
                              storageKey: null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    params: {
      operationKind: 'query',
      name: 'JobDetailsToggleFollowButtonQuery',
      id: null,
      text:
        'query JobDetailsToggleFollowButtonQuery(\n  $id: ID!\n  $withFollowers: Boolean!\n) {\n  job(id: $id) {\n    ...JobDetailsToggleFollowButton_job_4hJhOB\n    id\n  }\n}\n\nfragment JobDetailsToggleFollowButton_job_4hJhOB on JobNode {\n  id\n  isCurrentUserFollowing\n  followers {\n    edges @include(if: $withFollowers) {\n      node {\n        id\n        fullName\n      }\n    }\n    totalCount\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'cb7346c18ff94e43c41462f62e03b956';
module.exports = node;
